import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { PaginationStoreType } from '../../../../../stores/NewPaginationStore'
import {
  formControlSx,
  groupSelectButtonSx,
  groupSelectSx,
} from '../../../../Service/components/AdminTables/consts/table.styles'
import { useGroupOperations } from '../hooks/useGroupOperations'
import { RequestTableParamsType } from '../types/new-requests-table.types'

interface GroupOperationsProps {
  checkboxStore: any
  paginationStore: PaginationStoreType<RequestTableParamsType>
}

const GroupOperations: FC<GroupOperationsProps> = ({
  checkboxStore,
  paginationStore,
}) => {
  const {
    renderItems,
    onClick,
    classes,
    selectChanged,
    selectDisabled,
    onChange,
    onOpen,
    value,
    activeItem,
  } = useGroupOperations(checkboxStore, paginationStore)

  const renderValue = () => {
    const isDefaultValue =
      (!selectChanged && value === 'ВЫБЕРИТЕ ДЕЙСТВИЕ') || selectDisabled

    if (isDefaultValue) {
      return (
        <Typography sx={{ fontWeight: 500, color: '#5F5F5F' }}>
          Выберите действие
        </Typography>
      )
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {!!(activeItem && activeItem.icon) && (
          <img src={activeItem.icon} alt='item icon' />
        )}
        <Typography sx={classes.selectedItem}>
          {activeItem?.name ?? ''}
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={'fx-nowrap'} pr={2}>
      <FormControl sx={formControlSx}>
        <Select
          disabled={selectDisabled}
          value={value}
          onOpen={onOpen}
          onChange={onChange}
          renderValue={renderValue}
          sx={groupSelectSx(classes, selectDisabled)}
          MenuProps={{
            sx: classes.menuProps,
          }}
          IconComponent={(e) => (
            <img
              className={e.className}
              style={{ opacity: selectDisabled ? '0.3' : undefined }}
              src={getImageSrc('shevronDown')}
              alt={'arrow'}
            />
          )}
        >
          {renderItems.map((el: any) => (
            <MenuItem value={el?.name} key={el?.name} sx={classes.menuItem}>
              {el.icon && (
                <img
                  style={{ marginRight: '4px' }}
                  src={el.icon}
                  alt={el.name}
                />
              )}
              {el.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        sx={groupSelectButtonSx(classes, selectDisabled, activeItem)}
        disabled={selectDisabled || !activeItem?.action}
        onClick={onClick}
        variant={'contained'}
      >
        <FormattedMessage id={'Выполнить'} />
      </Button>
    </Box>
  )
}

export default observer(GroupOperations)
